import React from "react";
import { Package, Coins, Check } from "lucide-react";
import { GLASS, FONT, glassInner } from "../kota/ui";
import { chipStyle } from "../kota/Sheet";
import { MallPreview } from "./MallPreview";

// Paket tematik berdiskon (tab Rumah, filter Semua/Paket): kartu lebar berisi nama set, ringkasan barang,
// harga coret vs harga bundel, tombol beli paket. Barang yang sudah dimiliki ditandai.
export function PaketHemat({ sets, punya, busy, token, onBeli, onPilih, katalog }) {
  if (!sets?.length) return null;
  const byId = Object.fromEntries((katalog || []).map(it => [it.id, it]));   // item lengkap (paintCode) untuk pratinjau
  return (
    <section data-testid="mall-seksi-paket" style={{ marginBottom: 12, fontFamily: FONT }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "6px 4px 8px" }}>
        <b style={{ fontSize: 13, fontWeight: 800, color: GLASS.ink, display: "inline-flex", alignItems: "center", gap: 6 }}><Package size={14} /> Paket Hemat</b>
        <span style={{ fontSize: 11, color: GLASS.sub, fontWeight: 700 }}>hemat {sets[0].diskon}%</span>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {sets.map(s => {
          const semua = s.items.every(it => (punya[it.id] || 0) > 0);
          return (
            <div key={s.key} data-testid={`mall-paket-${s.key}`} style={{ ...glassInner(false), borderRadius: 18, padding: "10px 12px", display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                <div style={{ minWidth: 0 }}>
                  <b style={{ fontSize: 13.5, fontWeight: 800, color: GLASS.ink, display: "block" }}>{s.nama}</b>
                  <span style={{ fontSize: 11, color: GLASS.sub, fontWeight: 600, lineHeight: 1.4, display: "block" }}>{s.ket}</span>
                </div>
                <span style={{ ...chipStyle("red"), flex: "none", padding: "3px 8px", fontSize: 10 }}>-{s.diskon}%</span>
              </div>
              {/* Carousel isi paket: pratinjau gambar tiap barang (geser mendatar), ketuk → tampil di panggung */}
              <div data-testid={`mall-paket-carousel-${s.key}`} style={{ display: "flex", gap: 8, overflowX: "auto", scrollSnapType: "x mandatory", padding: "2px 2px 4px", margin: "0 -4px", WebkitOverflowScrolling: "touch" }}>
                {s.items.map(it => {
                  const full = byId[it.id] || it, dimiliki = (punya[it.id] || 0) > 0;
                  return (
                    <button key={it.id} data-testid={`mall-paket-item-${it.id}`} onClick={() => onPilih(it)} title={it.nama}
                      style={{ flex: "none", scrollSnapAlign: "start", width: 86, border: 0, borderRadius: 14, padding: 6, cursor: "pointer", fontFamily: FONT, background: dimiliki ? "rgba(46,158,91,.12)" : GLASS.inner, color: GLASS.ink, display: "flex", flexDirection: "column", alignItems: "center", gap: 4, position: "relative" }}>
                      <MallPreview item={full} size={64} width={74} />
                      <span style={{ fontSize: 10, fontWeight: 700, lineHeight: 1.2, textAlign: "center", color: dimiliki ? "#189a5b" : GLASS.ink, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{it.nama}</span>
                      <span style={{ fontSize: 9.5, fontWeight: 700, color: GLASS.sub }}>{it.harga} koin</span>
                      {dimiliki && <span style={{ position: "absolute", top: 4, right: 4, width: 16, height: 16, borderRadius: 99, background: "#189a5b", color: "#fff", display: "grid", placeItems: "center" }}><Check size={10} /></span>}
                    </button>
                  );
                })}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 11.5, color: GLASS.sub, fontWeight: 700, textDecoration: "line-through" }}>{s.harga_normal}</span>
                <b data-testid={`mall-paket-harga-${s.key}`} style={{ fontSize: 15, fontWeight: 800, color: GLASS.accent, display: "inline-flex", alignItems: "center", gap: 4 }}><Coins size={13} /> {s.harga_bundel}</b>
                <span style={{ flex: 1 }} />
                <button data-testid={`mall-paket-beli-${s.key}`} disabled={busy || !token} onClick={() => onBeli(s)}
                  style={{ height: 34, padding: "0 14px", borderRadius: 99, border: 0, background: GLASS.accent, color: "#fff", fontWeight: 800, fontSize: 12, cursor: "pointer", fontFamily: FONT, opacity: busy || !token ? .55 : 1 }}>
                  {!token ? "Masuk dulu" : semua ? "Beli lagi" : "Beli paket"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
